import { createApp } from 'vue';

if (document.getElementById('consultant-program-details-page')) {
    const app = createApp({
        data() {
            return {
              programId: null,
              users: [],
              errors: [],
              successMessage: [],
              fields: [
                {
                  key: 'name',
                  label: 'Name',
                  sortable: true,
                  'class': 'name'
                },
                {
                  key: 'email',
                  label: 'Email',
                  sortable: false,
                  'class': 'email'
                },
                {
                  key: 'phone',
                  label: 'Phone',
                  'class': 'phone'
                },
                {
                  key: 'additional_contact_info',
                  label: 'Additional Contact Info',
                  'class': 'additional'
                },
                {
                  key: 'edit',
                  label: 'Action',
                  'class': 'edit'
                }
              ],
              userId: null,
              email: null,
              phone: null,
              additional: null
            };
          },
        methods: {
            validate: function (e) {
                // console.log(this.user)
                this.errors = [];
                if (!this.email) this.errors.push('Email is required.')
                if (!this.errors.length) {
                    this.submit();
                }
            },
            submit() {
                
                axios.post('/api/program-users/edit', {
                    id: this.userId,
                    program_id: this.programId,
                    email: this.email,
                    phone: this.phone,
                    additional: this.additional

                })
                    .then(function (response) {
                        this.getProgramUsers()
                        this.hideModal()
                        this.successMessage.push('Sucessfully edited contact info')
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
            },
            getProgramUsers() {
                axios('/api/program-users/' + this.programId)
                    .then(function (response) {
                        this.users = response.data;
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
            },
            getProgramId() {
                var url = window.location.pathname;
                this.programId = url.substr(url.lastIndexOf('/') + 1);
            },
            clearForm() {
                this.email = null
                this.phone = null
                this.additional = null
                this.userId = null
            },
            showModal(user) {
                this.email = user.email
                this.phone = user.phone
                this.additional = user.additional_contact_info
                this.userId = user.id
                this.$refs.contactModal.show()
                this.successMessage = []
                this.errors = []
            },
            hideModal() {
                this.$refs.contactModal.hide()
                this.clearForm()
            },
        },
        mounted: function () {
            this.getProgramId()
            this.getProgramUsers()
        }
    });
    app.mount('#consultant-program-details-page');
}